exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".has-error label{color:#c11c0f}.has-error input{border-color:#c11c0f}.Gofilex img{position:fixed;z-index:6;top:2rem;bottom:0rem;right:1.5rem;height:1rem}@media (min-width: 1240px){.Gofilex img{top:3rem;bottom:0rem;right:3rem;height:2rem}}\n", ""]);
